<!--<div class="row" ng-show="showType == 'columns'">
<div class="col-md-6" ng-show="groups.length > 2">
  <div>
    <select class="form-control" ng-options="group.Name for group in groups track by group.DistributionObjectGroupId" ng-model="selectedDistributionObjectGroup"></select>
  </div>
</div>
<div class="col-md-6">
  <div>
    <select class="form-control" ng-options="distributionObject.Name for distributionObject in selectedDistributionObjectGroup.DistributionObjects track by distributionObject.DistributionObjectsId" ng-model="selectedDistributionObject">
      <option value="">{{nullValueText || 'All'}}</option>
    </select>
  </div>
</div>
</div>-->
<!--<div ng-show="!showType || showType == 'rows'">-->
@if (distributionObjectGroups?.length > 1) {
  <div class="form-group">
    <!-- Larger than 2 because of the "All" group -->
    <label>Document Type Groups</label>
    <select id="selectDocumentTypeGroups" class="form-control" [(ngModel)]="selectedDistributionObjectGroup" (ngModelChange)="distributionObjectGroupChanged($event)">
      <option [ngValue]="allGroup">All</option>
      @for (group of distributionObjectGroups; track group?.DistributionObjectGroupId) {
        <option [title]="group?.Description ?? ''" [ngValue]="group">{{group.Name}}</option>
      }
    </select>
  </div>
}

<div class="form-group">
  <label title="The different document types registered in Link">Document Types</label>
  <select id="selectDocumentTypes" class="form-control" [ngModel]="selectedDistributionObject" (ngModelChange)="distributionObjectChanged($event)">
    <option [ngValue]="null">All</option>
    @if (showSearchForUnknown && selectedDistributionObjectGroup == allGroup) {
      <option [ngValue]="unknownDistributionObject">{{unknownDistributionObject?.Name}}</option>
    }
    @for (distributionObject of selectedDistributionObjectGroup?.DistributionObjects; track distributionObject) {
      <option
        [title]="distributionObject.Description ?? ''"
      [ngValue]="distributionObject">{{distributionObject.Name}}</option>
    }

  </select>
</div>
<!--</div>-->
